<template>
    <div>
        <v-dialog v-model="viewAppointmentModal" max-width="500px" content-class="add-appointment view-edit">
            <v-card class="view-panel">
                <div class="modal-header">
                    <template>
                        <v-sheet>
                            <v-skeleton-loader class="pl-6"
                            type="heading" 
                            v-if="eventLoading === true"
                            :loading="eventLoading === true" width="200"
                            ></v-skeleton-loader>
                        </v-sheet>
                    </template>
                    <h4 v-show="eventLoading === false" class="modal-headline">
                        {{ selectedEvent.name }}
                    </h4>
                    <div class="tools">
                        <div class="tools-desktop" v-if="!$vuetify.breakpoint.xs">
                            <v-btn @click="openDeleteModal" icon id="view-button-delete"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                            <v-tooltip activator="#view-button-delete" bottom open-delay="500">
                                <span>{{$page.props.lang.delete || "Delete"}}</span>
                            </v-tooltip>

                            


                            <!-- <v-btn icon @click="cancelEvent" id="view-button-cancel"><v-icon>mdi-close-box-outline</v-icon></v-btn>
                            <v-tooltip activator="#view-button-cancel" bottom open-delay="500">
                                <span>{{$page.props.lang.cancel || "Cancel"}}</span>
                            </v-tooltip>

                            <ConfirmModal :open="showCancelModal"
                            @no="cancelFutureEvents(false)" 
                            @yes="cancelFutureEvents(true)"
                            @close="showCancelModal = false"
                            :title="$page.props.lang.cancelConfirmTitle || 'Confirm cancel'" 
                            :description="$page.props.lang.cancelConfirmDescription || 'Do You want to cancel only this event or this and all future events?'" 
                            :noText="$page.props.lang.cancelConfirmNoText || 'Only this'" 
                            :yesText="$page.props.lang.cancelConfirmYesText || 'This and all future'">
                            </ConfirmModal> -->




                            <v-btn
                            @click="openAttendance" 
                            icon id="view-button-attend"><v-icon>mdi-account-group-outline</v-icon></v-btn>
                            <v-tooltip activator="#view-button-attend" bottom open-delay="500">
                                <span>{{$page.props.lang.participants || "Participants"}}</span>
                            </v-tooltip>

                            <v-btn 
                            @click="(editAppointmentModal = true)"
                            icon id="view-button-edit"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                            <v-tooltip activator="#view-button-edit" bottom open-delay="500">
                                <span>{{$page.props.lang.edit || "Edit appointment"}}</span>
                            </v-tooltip>
                        </div>

                        <v-menu bottom left v-if="$vuetify.breakpoint.xs">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>

                            <v-list dense class="tools-mobile-list">
                                <v-list-item @click="openDeleteModal" link>
                                    <v-list-item-icon><v-icon>mdi-trash-can-outline</v-icon></v-list-item-icon>
                                    <v-list-item-title>{{$page.props.lang.delete || "Delete"}}</v-list-item-title>
                                </v-list-item>
                                <!-- <v-list-item @click="cancelEvent" link>
                                    <v-list-item-icon><v-icon>mdi-close-box-outline</v-icon></v-list-item-icon>
                                    <v-list-item-title>{{$page.props.lang.cancel || "Cancel"}}</v-list-item-title>
                                </v-list-item> -->
                                <v-list-item @click="openAttendance" link>
                                    <v-list-item-icon><v-icon>mdi-checkbox-marked-outline</v-icon></v-list-item-icon>
                                    <v-list-item-title>{{$page.props.lang.attendance || "Attendance"}}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="(editAppointmentModal = true, viewAppointmentModal = false)" link>
                                    <v-list-item-icon><v-icon>mdi-pencil-outline</v-icon></v-list-item-icon>
                                    <v-list-item-title>{{$page.props.lang.edit || "Edit appointment"}}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                        <ConfirmModal :open="showDeleteModal"
                            @no="showDeleteModal = false" 
                            @yes="deleteEvent" 
                            @close="showDeleteModal = false"
                            :description="$page.props.lang.deleteConfirmDescription || 'Are You sure You want to delete event?'">
                            </ConfirmModal>
                           
                            <ReccuringModal :open="showDeleteAllModal"
                            @no="deleteAllEvents(false)" 
                            @yes="deleteAllEvents(true)"
                            @close="showDeleteAllModal = false"
                            :description="$page.props.lang.deleteAllConfirmDescription || 'Do You want to delete only this or this and all future events?'"
                            :noText="$page.props.lang.deleteAllConfirmNoText || 'Only this'" 
                            :yesText="$page.props.lang.deleteAllConfirmYesText || 'This and all future'">
                            </ReccuringModal>
                        <v-btn icon @click="viewAppointmentModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="info-container">
                    <template>
                        <v-sheet>
                            <v-skeleton-loader
                            type="article, article" 
                            v-show="eventLoading === true"
                            :loading="eventLoading === true"
                            ></v-skeleton-loader>
                        </v-sheet>
                    </template>
                    <div v-show="eventLoading === false" transition="fade-transition">
                        <div class="grid bottom">
                            <div class="info-group">
                                <div class="icon-wrap"><v-icon>mdi-calendar-text-outline</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.date || "Date" }}</p>
                                    <p class="value">{{ selectedEvent.start | formatDate }}</p>
                                </div>
                            </div>
                            <div class="info-group">
                                <div class="icon-wrap"><v-icon>mdi-clock-outline</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.time || "Time" }}</p>
                                    <p class="value">{{ selectedEvent.start | formatTime }} - {{ selectedEvent.end | formatTime }}</p> 
                                </div>
                            </div>
                            <div class="info-group">
                                <div class="icon-wrap"><v-icon>mdi-progress-clock</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.duration || "Duration" }}</p>
                                    <p class="value">{{ selectedEvent.duration }} <span class="min">min</span></p>
                                </div>
                            </div>
                            <div class="info-group" v-if="selectedEvent.location != null">
                                <div class="icon-wrap"><v-icon>mdi-map-marker-outline</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.location || "Location" }}</p>
                                    <p class="value">{{ selectedEvent.location.name }}</p>
                                </div>
                            </div>
                            <div class="info-group">
                                <div class="icon-wrap"><v-icon>mdi-format-list-numbered</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.booked || "Booked" }}</p>
                                    <p class="value">{{ selectedEvent.booked_seats }}/{{ selectedEvent.max_seats }}</p>
                                </div>
                            </div>
                            <div class="info-group">
                                <div class="icon-wrap"><v-icon>mdi-account-outline</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.trainer || "Trainer" }}</p>
                                    <p class="value">{{ selectedEvent.trainer.full_name }}</p>
                                </div>
                            </div>
                            <div v-if="selectedEvent.is_online == true" class="info-group">
                                <div class="icon-wrap"><v-icon>mdi-link</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.online_training || "Online Training" }}</p>
                                    <a style="font-size:0.855rem;" :href="selectedEvent.session_url" target="_blank">{{selectedEvent.session_url}}</a>
                                </div>
                            </div>
                        </div>
                        <div class="clients-group">
                            <div class="container mb-3">
                                <v-row>
                                    <v-col cols="12">
                                       <p class="label"><v-icon>mdi-account-group-outline</v-icon>{{ $page.props.lang.participants || "Participants" }}</p>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-data-table 
                                            hide-default-header 
                                            hide-default-footer 
                                            :headers="participantHeaders"
                                            :items="selectedEvent.clients">
                                            <template v-slot:item.full_name="{ item }">
                                                 <a :href="'/backoffice/members/details/'+item.id +'/overview'" class="name" target="_blank" style="display: flex; flex-direction: row; align-items: center;">
                                                    <v-avatar size="40">
                                                        <img :src="item.profile_photo" alt="">
                                                    </v-avatar>
                                                    <div style="display:inline-block; line-height:1em">
                                                        {{ item.full_name }}<br>
                                                        <span style="color: #444; font-size:10px">{{item.membership}}</span>
                                                    </div>
                                                 </a>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                    <!-- <v-col cols="6">
                                         <v-btn v-if="canSendMessage" color="primary" small outlined  @click="smsModal = true" style="position:absolute; right:19px">
                                            <v-icon style="margin-right:3px" small>mdi-message</v-icon>
                                            <span v-if="this.$vuetify.breakpoint.mdAndUp"> {{ $page.props.lang.message || "Message" }} </span></v-btn>
                                    </v-col> -->
                                </v-row>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-dialog>

        

        <AttendModal
        v-if="attendAppointmentModal"
        :open="attendAppointmentModal"
        :appointment="appointment"
        :clientsLoading="clientsLoading"
        @fetchCurrent="$emit('fetchCurrent')"
        @close="attendAppointmentModal = false">
        </AttendModal>

        <EditModal
        :open="editAppointmentModal"
        :locations="locations"
        :editAppointment="editAppointment"
        :trainers="trainers"
        :courses="courses"
        @fetchCurrent="$emit('fetchCurrent')"
        @close="editAppointmentModal = false">
        </EditModal>

        <SmsModalMembers
        v-if="smsModal"
        :open="smsModal"
        :sms_credit="sms_credit"
        :use_mobile_app="use_mobile_app"
        :recipients="selectedMembersComputed"
        @close="smsModal = false">
        </SmsModalMembers>
    </div>
</template>

<script>
import ConfirmModal from '@/js/Components/ConfirmModal'
import AttendModal from '@/js/Pages/Backoffice/Calendar/Components/AttendModal'
import EditModal from '@/js/Pages/Backoffice/Calendar/Components/EditModal'
import SmsModalMembers from '@/js/Pages/Backoffice/Members/Components/SmsModalMembers'
import ReccuringModal from '@/js/Pages/Backoffice/Calendar/Components/ReccuringModal'
import AddNoteModal  from '@/js/Pages/Backoffice/Calendar/Components/AddNoteModal'
import Note from '@/js/Components/Note'
import EventBus from '@/js/eventbus'

export default {
    components: {
        ConfirmModal,
        AttendModal,
        EditModal,
        ReccuringModal,
        SmsModalMembers,
        AddNoteModal,
        Note
    },
    props: {
        open: Boolean,
        trainers: Array,
        locations: Array,
        courses: Array,
        selectedEvent: Object,
        editAppointment: Object,
        sms_credit: Number,
        use_mobile_app: Number,
        pickedColor: String,
        eventLoading: Boolean
    },
    data(){
        return {
            today : moment().format('YYYY-MM-DD'),
            tabs: 'participants',
            isLoading: false,
            editAppointmentModal: false,
            colors: [
                '#4CAF50', //green
                '#2196F3', //blue
                '#9C27B0', //purple
                '#607D8B', //blue-grey
                '#FF5722', //deep-orange
                '#CDDC39', //lime
            ],
            appointment: null,
            messageObjects: [],
            responseErrors: {},
            selectedElement: null,
            selectedEventOpen: false,
            attendanceClients: [],
            attendAppointmentModal: false,
            showCancelModal: false,
            showDeleteModal: false,
            showDeleteAllModal: false,
            clientsLoading: false,
            smsModal:false,
            participantHeaders: [
                {
                    text: 'ss',
                    width: '20px',
                    value: 'full_name',
                },
                {
                    text: 'Actions',
                    align: 'start',
                    value: null,
                },
                
            ],
        }
    },
    computed: {
        viewAppointmentModal: {
            get: function() {
                return this.open
            },
            set: function() {
                this.$emit('close')
                return false
            }
        },

        selectedMembersComputed(){
           return this.selectedEvent.clients.map(function(el){
                return {id: el.id, full_name:el.full_name, profile_photo_url: el.profile_photo};
            })
        },

        canSendMessage(){
             if(this.selectedEvent.clients === undefined || this.selectedEvent.clients.length == 0){
                return false;
            }else{
                return true;
            }
        }
    },
    methods: {
        openDeleteModal() {
            if(this.selectedEvent.parent_id || this.selectedEvent.recurring == 1) {
                this.showDeleteAllModal = true
            } else {
                this.showDeleteModal = true
            }
        },
        deleteEvent() {
            axios.post('/backoffice/calendar/appointment/remove', {id: this.selectedEvent.id, all_future: false})
                .then(response => {
                    
                    if (response.data.status==="OK") {
                        this.showDeleteModal = false
                        this.viewAppointmentModal = false
                        this.$emit('fetchCurrent')
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {
                   EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
        },
        deleteAllEvents(value) {
            axios.post('/backoffice/calendar/appointment/remove', {id: this.selectedEvent.id, all_future: value})
                .then(response => {
                    
                    if (response.data.status==="OK") {
                        this.showDeleteAllModal = false
                        this.viewAppointmentModal = false
                        this.$emit('fetchCurrent')
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {                    
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message:error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
        },
        cancelEvent() {
            if (this.selectedEvent.parent_id) {
                this.showCancelModal = true
            } else {
                axios.post('/backoffice/calendar/appointment/status', {id: this.selectedEvent.id, all_future: false, status: 0})
                    .then(response => {
                        
                        if (response.data.status==="OK") {
                            this.showCancelModal = false
                            this.viewAppointmentModal = false
                            this.$emit('fetchCurrent')
                            EventBus.$emit('SHOW_NOTIFICATION',{ 
                                    message: response.data.message,
                                    color: 'success',
                                    timeout: 5000
                                })
                        }
                    })
                    .catch(error => {
                        
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: error.response.data.message,
                                color: 'error',
                                timeout: 10000
                            })
                    })
            }
        },
        cancelFutureEvents(value) {
            axios.post('/backoffice/calendar/appointment/status', {id: this.selectedEvent.id, all_future: value, status: 0})
                .then(response => {
                    
                    if (response.data.status==="OK") {
                        this.showCancelModal = false
                        this.viewAppointmentModal = false
                        this.$emit('fetchCurrent')
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {
                    
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
        },
        openAttendance() {
            
            axios.get('/backoffice/calendar/appointment/attendance/' + this.selectedEvent.id)
                .then(response => {
                    if(response.data) {
                        this.appointment = response.data.appointment
                        // this.viewAppointmentModal = false
                        this.clientsLoading = true
                        this.attendAppointmentModal = true
                    }
                })
                .then(() => {
                    this.clientsLoading = false
                })
        }
    },
    filters:{
        
        formatDateRange: function(value) {
            return moment(String(value)).format('DD/MM/YYYY')
        },
        formatIndex: function(value) {
                return value < 10 ? '0' + value : value
        }
    },
    created() {
       EventBus.$on('REMOVE_MEMBER_FROM_APPOINTMENT', (p) => {
        let member = this.selectedEvent.clients.find(i => i.id == p.id);

            if(member != null){
                this.selectedEvent.clients.splice(this.selectedEvent.clients.indexOf(member), 1);
            }
        
           
        })
    }
}
</script>